import React, {FC} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {Field, ErrorMessage} from 'formik'

const Step5: FC = () => {
  return (
    <div className='w-100'>
      <div className='row'>
        <div className='fv-row mb-10 col-lg-6'>
              <label className='form-label required'>Date</label>

              <Field name='basicSalary' className='form-control form-control-lg form-control-solid' />
              <div className='text-danger mt-2'>
                <ErrorMessage name='basicSalary' />
              </div>
        </div>
        <div className='fv-row mb-10 col-lg-6'>
              <label className='form-label required'>Note</label>

              <Field name='basicSalary' className='form-control form-control-lg form-control-solid' />
              <div className='text-danger mt-2'>
                <ErrorMessage name='basicSalary' />
              </div>
        </div>
      </div>
    </div>
  )
}

export {Step5}
